export const AGREEMENT_CONSENT_REQUIRED_ERROR_MESSAGE = 'This consent is required';

export const AGREEMENT_CONSENT_CHECKBOX_FIELDS = [
  {
    name: 'consent_electronic_delivery_via_email',
    label: 'I consent to receive electronic delivery of communication via email.',
  },
  {
    name: 'consent_text_messages_regarding_aba_services',
    label:
      "I consent to receive text messages from Forta staff as it pertains to immediate platforms of communication for the client's ABA Services.",
  },
  {
    name: 'consent_electronic_signature_platform',
    label:
      'I consent to using Dropbox Sign or similar electronic signature platform to sign any and all documents requiring my signature to authorize ABA Services.',
  },
  {
    name: 'consent_complete_required_assessments',
    label:
      "I consent to complete required assessments as dictated by the client's insurance provider and/or at the request of Forta staff to properly develop an appropriate treatment plan for the client's ABA Services.",
  },
  {
    name: 'consent_paper_document_delivery_notice',
    label:
      'I consent to and understand if I prefer to receive documents in paper form, I must communicate this to the Clinical Lead or Client Success Manager. Changes to these preferences may take up to ten (10) business days.',
  },
  {
    name: 'consent_electronic_delivery_freely_given',
    label:
      'I fully and freely give consent to engage in electronic delivery and communications with Forta.',
  },
] as const;
